export default "__VITE_ASSET__LLASDbrR__"